import ConsultarDenunciaHeader from './ConsultarDenunciaHeader';

export default ConsultarDenunciaHeader;
